import { Inject } from '@odinjs/odin';

import { Endpoint, FOUNDATION_ROUTES } from '@philips-emr/hpms-stipulator-commons';
import { TermsService } from '@philips-emr/hpms-stipulator-commons/lib/services/terms-service';
import { HpmsTextHtmlAPI } from '@philips-emr/hpms-stipulator-components';
import { FormAPI, ToastNotificationAPI } from '@philips-emr/tws-components';
import Controller, { OnCancel, OnMount, OnSubmit } from '@philips-emr/tws-core/lib/client';
import { MountEvent, SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { AuthenticationService, HttpService, ModalService } from '@philips-emr/tws-core/lib/services';

import { FragmentNames } from '../codegen';
import { AssignTermAliases as Aliases } from '../codegen/constants/aliases/assign-term-aliases';

import BaseController from './BaseController';

@Controller({ fragment: FragmentNames.ASSIGN_TERM })
class AssignTermController extends BaseController {

  @Inject(Aliases.HPMS_TEXT_HTML_TERM)
  private textHtml: HpmsTextHtmlAPI;
  @Inject(Aliases.TOAST_NOTIFICATION_TERM)
  private toastNotificationAPI: ToastNotificationAPI;

  @OnMount(Aliases.FORM_TERM)
  onMountForm(event: MountEvent): void {
    const { dsTermo, nrSequencia, tipo } = this.context.getBulkData();

    const apiForm = event.target as unknown as FormAPI;
    apiForm.setData({ nrSequencia, tipo });

    this.textHtml.setValue(String(dsTermo));
  }

  @OnSubmit(Aliases.FORM_TERM)
  onSubmitTerm(event: SubmitEvent): void {
    const { record } = event;

    this.toastNotificationAPI.setVisible(!record?.checked);

    if (record?.checked) {
      void HttpService.post(Endpoint.POST.TERMOS, {}, { body: record }).then(() => {
        ModalService.close('term-modal');
        TermsService.checkTerms();
      });
    } else {
      this.scrollDownPanelTerm();
    }
  }

  @OnCancel(Aliases.FORM_TERM)
  onCancel(): void {
    void AuthenticationService.logout().then(() => {
      this.historyService.push(FOUNDATION_ROUTES.LOGIN);
    });
  }

  scrollDownPanelTerm(): void {
    const termPanel = document.querySelector<HTMLDivElement>('.c-modal__content--with-stack-manager');

    if (termPanel) {
      const { scrollHeight } = termPanel;

      termPanel.scrollTo({ top: scrollHeight, behavior: 'smooth' });
    }
  }
}

export default AssignTermController;
